import {
  settlementTypes,
  streetTypes,
  houseTypes,
  buildingTypes,
  apartmentTypes,
} from './ManualAddressForm.constants';

export const getSettlementTypesList = () => {
  return settlementTypes.map((i) => ({ id: i.id, title: i.typeFull }));
};

export const getStreetTypesList = () => {
  return streetTypes.map((i) => ({ id: i.id, title: i.typeFull }));
};

export const getHouseTypesListList = () => {
  return houseTypes.map((i) => ({ id: i.id, title: i.typeFull }));
};

export const getBuildingTypesList = () => {
  return buildingTypes.map((i) => ({ id: i.id, title: i.typeFull }));
};

export const getApartmentTypesList = () => {
  return apartmentTypes.map((i) => ({ id: i.id, title: i.typeFull }));
};

export const findEntityByType = (type, dict) => {
  return dict.find((i) => i.type === type);
};

export const findItemById = (dict, id) => {
  return dict.find((i) => i.id === id);
};

export const getValidationErrors = (errors) => {
  const result = {};
  errors.inner.forEach((e) => {
    result[e.path] = e.message;
  });
  return result;
};

export const prepareResultObject = (
  data,
  apartmentType,
  buildingType,
  houseType,
  streetType,
  settlementType
) => {
  const result = {
    ...data,
    fiasCode: '',
    fiasId: '',
    fiasLevel: '',
    fiasValue: '',
    houseFiasId: '',
    settlementFiasId: '',
    settlementKladrCode: '',
    streetFiasId: '',
    streetKladrCode: '',
    apartmentType: '',
    apartmentTypeFull: '',
    apartment: '',
    buildingType: '',
    buildingTypeFull: '',
    houseType: '',
    houseTypeFull: '',
    streetType: '',
    streetTypeFull: '',
    streetWithType: '',
    settlementType: '',
    settlementTypeFull: '',
    settlementWithType: '',
    indexNumber: '',
  };

  if (apartmentType && data.apartmentNumber) {
    const apartmentObj = apartmentTypes.find((i) => i.id === apartmentType.id);
    result.apartmentType = apartmentObj.type;
    result.apartmentTypeFull = apartmentObj.typeFull;
    result.apartment = apartmentObj.typeFull;
  } else {
    result.apartmentType = '';
    result.apartmentTypeFull = '';
    result.apartment = '';
  }

  if (buildingType && data.building) {
    const buildingObj = buildingTypes.find((i) => i.id === buildingType.id);
    result.buildingType = buildingObj.type;
    result.buildingTypeFull = buildingObj.typeFull;
  } else {
    result.buildingType = '';
    result.buildingTypeFull = '';
  }

  if (houseType && data.houseNumber) {
    const houseObj = houseTypes.find((i) => i.id === houseType.id);
    result.houseType = houseObj.type;
    result.houseTypeFull = houseObj.typeFull;
  } else {
    result.houseType = '';
    result.houseTypeFull = '';
  }

  if (streetType && data.streetName) {
    const streetObj = streetTypes.find((i) => i.id === streetType.id);
    result.streetType = streetObj.type;
    result.streetTypeFull = streetObj.typeFull;
    result.streetWithType = `${streetObj.type} ${data.streetName}`;
  } else {
    result.streetType = '';
    result.streetTypeFull = '';
    result.streetWithType = '';
  }

  if (settlementType && data.settlementName) {
    const settlementObj = settlementTypes.find((i) => i.id === settlementType.id);
    result.settlementType = settlementObj.type;
    result.settlementTypeFull = settlementObj.typeFull;
    result.settlementWithType = `${settlementObj.typeFull} ${data.settlementName}`;
  } else {
    result.settlementType = '';
    result.settlementTypeFull = '';
    result.settlementWithType = '';
  }

  return result;
};
